import(/* webpackMode: "eager" */ "/vercel/path0/src/app/[locale]/signature-journeys/page.tsx");
